<template>
	<div class="letter-recievers-groups">
        <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
                <li class="breadcrumb-item">
                    <a :href=route_back>Группы получателей</a>
                </li>
                <li class="breadcrumb-item active" aria-current="page">Добавить группу получателей</li>
            </ol>
        </nav>

		<div class="letter-recievers-groups__recievers">
			<div class="mb-4">
				<label class="input-label">Название группы <span class="color-red">*</span></label>
				<input v-model="formData.name" id="recieverEmail" type="text" class="form-control input-field">
			</div>
		</div>

		<div class="letter-recievers-groups__recievers">
            <div style="position: relative;" class="mb-4 input-field">
                <label class="form-label">Email адреса <span class="color-red">*</span></label>
                <input ref="emailInput"
                       v-model="receiversEmails"
                       @keypress.enter="validateEmails"
                       type="text"
                       :class="emailError ? 'form-control input-error' : 'form-control'"
                       placeholder="Разделить через пробел"
                >
                <p class="text-error" v-if="emailError">{{ emailError }}</p>
            </div>

            <svg @click="validateEmails" class="email-add-btn" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9 12L11 14L15 10M3 12C3 13.1819 3.23279 14.3522 3.68508 15.4442C4.13738 16.5361 4.80031 17.5282 5.63604 18.364C6.47177 19.1997 7.46392 19.8626 8.55585 20.3149C9.64778 20.7672 10.8181 21 12 21C13.1819 21 14.3522 20.7672 15.4442 20.3149C16.5361 19.8626 17.5282 19.1997 18.364 18.364C19.1997 17.5282 19.8626 16.5361 20.3149 15.4442C20.7672 14.3522 21 13.1819 21 12C21 10.8181 20.7672 9.64778 20.3149 8.55585C19.8626 7.46392 19.1997 6.47177 18.364 5.63604C17.5282 4.80031 16.5361 4.13738 15.4442 3.68508C14.3522 3.23279 13.1819 3 12 3C10.8181 3 9.64778 3.23279 8.55585 3.68508C7.46392 4.13738 6.47177 4.80031 5.63604 5.63604C4.80031 6.47177 4.13738 7.46392 3.68508 8.55585C3.23279 9.64778 3 10.8181 3 12Z" stroke="#0678F4" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
		</div>

        <div v-if="emails.length" class="letter-recievers-groups__selected-recievers mb-4">
			<div class="selected-reciever"
				v-for="(item, index) in emails">
					{{ item }}
					<svg @click="removeEmail(index, item.id)" class="selected-reciever__button" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
						<g clip-path="url(#clip0_641_26163)">
							<path d="M12 4L4 12" stroke="#242731" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
							<path d="M4 4L12 12" stroke="#242731" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
						</g>
						<defs>
							<clipPath id="clip0_641_26163">
								<rect width="16" height="16" fill="white"/>
							</clipPath>
						</defs>
					</svg>
			</div>
		</div>

		<div class="letter-recievers-groups__control-buttons">
            <ConfirmBtn :class="'btn btn-lg btn-primary me-3'" :text="'Сохранить'" @btnClick="createGroup"/>
			<a :href="route_back" id="cancelButton" class="btn btn-lg btn-outline-dark me-3">Отменить</a>
		</div>

        <Alert />
	</div>
</template>

<script>
import ConfirmBtn from '../../../../elements/ConfirmBtn.vue';
import Receivers from '../../../../models/Mailings/Receivers'
import Alert from '../../../alerts/Alert.vue';
import { mapMutations } from 'vuex/dist/vuex.cjs.js';

export default {
	name: 'RecieversGroupAddComponent',
    components: { Alert, ConfirmBtn },
    props: {
        route_back: String,
        route_create: String
    },
	data: function () {
		return {
            receivers: new Receivers({
                route_create: this.route_create,
            }),
            formData: {
                name: null,
            },
            emailError: '',
            receiversEmails: '',
            alertMessage: '',
            emails: [],
		};
    },
    methods: {
        ...mapMutations('alerts', ['addAlert']),
        ...mapMutations('ui', ['toggleLoading']),
        createGroup: async function () {
            this.validateEmails();

            if (this.formData.name == null) {
                this.addAlert({ type: 'warning', title: 'Предупреждение', text: 'Введите название группы!' });
                this.toggleLoading();
                return;
            }

            if (!this.emails.length && !this.emailError) {
                this.addAlert({ type: 'warning', title: 'Предупреждение', text: 'Добавьте хотя бы одного получателя!' });
                this.toggleLoading();
                return;
            }

            if (this.emailError) {
                this.toggleLoading();
                return;
            }

            let response = await axios.post(this.route_create, {
                name: this.formData.name,
                emails: this.emails.join(' ')
            });

            if (response.data.status == 'ok') {
                window.location.href = this.route_back;
            } else {
                this.addAlert({ type: 'success', title: 'Успешно', text: response.data.message });
            }
        },
        removeEmail: async function (index) {
            this.emails.splice(index, 1);
        },
        validateEmails() {
            if (!this.receiversEmails) return;
            const emailPattern = /^(?!.*\.\.)[\w.-]+@[a-zA-Z\d.-]+\.[a-zA-Z]{2,}$/;
            const emails = this.receiversEmails.trim().split(/\s+/);
            let invalidEmails = [];

            emails.forEach(email => {
                if (emailPattern.test(email) && !this.emails.includes(email)) {
                    this.emails.push(email);
                } else {
                    invalidEmails.push(email);
                    this.emailError = 'Проверьте, что адреса соответствуют формату (a@a.ru), разделены пробелом, не содержат кириллицы и запрещённых символов ( , : ! и т.п), а также не повторяются.';
                    // this.toggleLoading();
                }
            });
            this.receiversEmails = invalidEmails.join(' ');
            if (!this.receiversEmails) this.emailError = '';
        },
    },
    watch: {
        receiversEmails: {
            handler(newValue) {
                if (newValue === '') this.emailError = '';
            }
        }
    }
}

</script>

<style scoped lang="scss">
.letter-recievers-groups {
    &__recievers {
        display: flex;
        flex-direction: row;
        align-items: center;
        width: 100%;
        gap: 60px;
    }
    &__selected-recievers {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        gap: 12px;
    }
    &__control-buttons {
        display: flex;
        flex-direction: row;
        gap: 4px;
    }
}
.input-label {
    font-size: 14px;
    font-weight: 600;
}
.page-label {
    font-size: 18px;
    font-weight: 600;
}
.input-field {
    width: 400px;
    &__date {
        width: 300px;
    }
}
.selected-reciever {
    border: 1px solid #EAEEF4;
    border-radius: 5px;
    padding: 5px 8px;
    &__button {
        cursor: pointer;
    }
    &__button:hover {
        path {
            stroke: red;
            transition: stroke 0.15s ease;
        }
    }
}
.text-error {
    font-size: 12px;
    font-weight: 400;
    margin: 0;
    color: #E33535;
}

.input-error {
    border: 1px solid #E33535;
}

.letter-recievers-groups {
    &__recievers {
        display: flex;
        flex-direction: row;
        align-items: center;
        width: 100%;
        gap: 60px;
    }
    &__selected-recievers {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        gap: 12px;
    }
    &__control-buttons {
        display: flex;
        flex-direction: row;
        gap: 4px;
    }
}

.email-add-btn {
    align-self: center;
    margin-left: -46px;
    cursor: pointer;
}
</style>